export const USERS_SELF = "user/get-my-profile";
export const MY_PERMISSIONS = "user/get-my-permissions";

export const GET_MASTER_IBL_PERIOD = "master/ibl_period";
export const GET_MASTER_TICKET_CATEGORY = "master/ticket_category";
export const GET_MASTER_TICKET_SUB_CATEGORY = "master/ticket_sub_category";
export const GET_MASTER_DROPDOWN = "master/dropdown";
export const GET_MASTER_IBL_MONTH = "master/ibl_month";

export const GET_MASTER_FILE_STATUS = "master/file/status";

export const CREATE_GET_TICKET = "ticket";
export const GET_TICKET_COUNTS = "ticket/counts";
export const GET_TICKET_AGENT_LIST = "ticket/agent-list";
export const CHECK_TICKET_NUDGE = "nudge";

export const GET_CONTACT_ROLES = "contact/roles";
export const GET_CONTACT_EMPLOYEES_BY_ROLE = (role_id: string) =>
  "contact/employees/" + role_id;

export const API_UPLOAD_DOCUMENT_PATH = `fileupload/path`;
export const API_UPLOAD_ADMIN_DOCUMENT_PATH = `fileupload/admin/upload/path`;

export const API_GET_FILES_CATEGORIES = `files/category`;
export const API_GET_FILES_BY_CATEGORY = (category_id: string) => `files/${category_id}`;
export const API_VALIDATE_FILE = `files/validate`;
export const API_POLL_STATUS_FILE_ADMIN = `files/poll-status`;

export const API_DASHBOARD_LIST = `dashboard/get-dashboard-list`;
export const API_DASHBOARD_EMBED_URL = `dashboard/get-embed-token`;

export const API_GET_AUDIENCE_KEYS = `announcement/audience/get-keys`;
export const API_GET_AUDIENCE_KEYS_VALUES = `announcement/audience/get-values`;
export const API_PUT_AUDIENCE_QUERY_BUILDER = `announcement/audience/create/query-builder`;
export const API_PREVIEW_AUDIENCE_QUERY = `announcement/audience/query/preview`;
export const API_PUT_AUDIENCE_CSV = `announcement/audience/create/csv`;
export const API_PUT_ANNOUNCEMENT = `announcement`;
export const API_ANNOUCEMENT_UPLOAD_CSV_PATH = `announcement/upload-csv/path`;
export const API_ANNOUCEMENT_UPLOAD_PATH = `announcement/upload/path`;
export const API_GET_AUDIENCE_LIST = `announcement/audience`;
export const API_GET_ANNOUNCEMENT_LIST = `announcement`;
export const API_GET_ANNOUNCEMENT_CATEGORIES = `announcement/category`;
export const API_GET_AUDIENCE_LIST_MINIMAL = `announcement/audience/names`;
export const API_ANNOUNCEMENT_ACTION = `announcement/action`;
export const API_GET_USER_ANNOUNCEMENTS = `user-announcement`;
